import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translations
import enNavigation from './locales/en/navigation.json';
import enAuth from './locales/en/auth.json';
import enForms from './locales/en/forms.json';
import enFamilies from './locales/en/familiespage.json';
import enDocumentation from './locales/en/documentation.json';
import enDocumentationPage from './locales/en/documentationpage.json';
import enProductDetailPage from './locales/en/productdetailpage.json';
import enImports from './locales/en/imports.json';
import enMarketing from './locales/en/marketingpage.json';
import enProductstable from './locales/en/productstable.json';
import enDashboard from './locales/en/dashboardpage.json';
import enReportspage from './locales/en/reportspage.json';
import enTeampage from './locales/en/teampage.json';
import enSettingspage from './locales/en/settingspage.json';
import enAttributeGroupsPage from './locales/en/attributegroupspage.json';
import enAttributesPage from './locales/en/attributespage.json';
import enFieldLabels from './locales/en/fieldLabels.json';
import enSearch from './locales/en/search.json';
import enErrors from './locales/en/errors.json';
import enBigCommerce from './locales/en/bigcommerce.json';
import enPlanLimits from './locales/en/planlimits.json';
import enLegal from './locales/en/legal.json';
import enRequestOrganization from './locales/en/requestorganization.json';
import enCommon from './locales/en/common.json';
import enTours from './locales/en/tours.json';

// Import Spanish translations (when available)
import esNavigation from './locales/es/navigation.json';
import esAuth from './locales/es/auth.json';
import esForms from './locales/es/forms.json';
import esFamilies from './locales/es/familiespage.json';
import esDocumentation from './locales/es/documentation.json';
import esDocumentationPage from './locales/es/documentationpage.json';
import esProductDetailPage from './locales/es/productdetailpage.json';
import esImports from './locales/es/imports.json';
import esMarketing from './locales/es/marketingpage.json';
import esProductstable from './locales/es/productstable.json';
import esDashboard from './locales/es/dashboardpage.json';
import esReportspage from './locales/es/reportspage.json';
import esTeampage from './locales/es/teampage.json';
import esSettingspage from './locales/es/settingspage.json';
import esAttributeGroupsPage from './locales/es/attributegroupspage.json';
import esAttributesPage from './locales/es/attributespage.json';
import esFieldLabels from './locales/es/fieldLabels.json';
import esSearch from './locales/es/search.json';
import esErrors from './locales/es/errors.json';
import esBigCommerce from './locales/es/bigcommerce.json';
import esPlanLimits from './locales/es/planlimits.json';
import esLegal from './locales/es/legal.json';
import esRequestOrganization from './locales/es/requestorganization.json';
import esCommon from './locales/es/common.json';
import esTours from './locales/es/tours.json';

// Import German translations
import deNavigation from './locales/de/navigation.json';
import deAuth from './locales/de/auth.json';
import deForms from './locales/de/forms.json';
import deFamilies from './locales/de/familiespage.json';
import deDocumentation from './locales/de/documentation.json';
import deDocumentationPage from './locales/de/documentationpage.json';
import deProductDetailPage from './locales/de/productdetailpage.json';
import deImports from './locales/de/imports.json';
import deMarketing from './locales/de/marketingpage.json';
import deProductstable from './locales/de/productstable.json';
import deDashboard from './locales/de/dashboardpage.json';
import deReportspage from './locales/de/reportspage.json';
import deTeampage from './locales/de/teampage.json';
import deSettingspage from './locales/de/settingspage.json';
import deAttributeGroupsPage from './locales/de/attributegroupspage.json';
import deAttributesPage from './locales/de/attributespage.json';
import deFieldLabels from './locales/de/fieldLabels.json';
import deSearch from './locales/de/search.json';
import deErrors from './locales/de/errors.json';
import deBigCommerce from './locales/de/bigcommerce.json';
import dePlanLimits from './locales/de/planlimits.json';
import deLegal from './locales/de/legal.json';
import deRequestOrganization from './locales/de/requestorganization.json';
import deCommon from './locales/de/common.json';
import deTours from './locales/de/tours.json';

// Import Portuguese translations
import ptNavigation from './locales/pt/navigation.json';
import ptAuth from './locales/pt/auth.json';
import ptForms from './locales/pt/forms.json';
import ptFamilies from './locales/pt/familiespage.json';
import ptDocumentation from './locales/pt/documentation.json';
import ptDocumentationPage from './locales/pt/documentationpage.json';
import ptProductDetailPage from './locales/pt/productdetailpage.json';
import ptImports from './locales/pt/imports.json';
import ptMarketing from './locales/pt/marketingpage.json';
import ptProductstable from './locales/pt/productstable.json';
import ptDashboard from './locales/pt/dashboardpage.json';
import ptReportspage from './locales/pt/reportspage.json';
import ptTeampage from './locales/pt/teampage.json';
import ptSettingspage from './locales/pt/settingspage.json';
import ptAttributeGroupsPage from './locales/pt/attributegroupspage.json';
import ptAttributesPage from './locales/pt/attributespage.json';
import ptFieldLabels from './locales/pt/fieldLabels.json';
import ptSearch from './locales/pt/search.json';
import ptErrors from './locales/pt/errors.json';
import ptBigCommerce from './locales/pt/bigcommerce.json';
import ptPlanLimits from './locales/pt/planlimits.json';
import ptLegal from './locales/pt/legal.json';
import ptRequestOrganization from './locales/pt/requestorganization.json';
import ptCommon from './locales/pt/common.json';
import ptTours from './locales/pt/tours.json';

// Deep merge function to prevent key collisions
function deepMerge(target: any, ...sources: any[]): any {
  if (!sources.length) return target;
  const source = sources.shift();

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} });
        deepMerge(target[key], source[key]);
      } else {
        Object.assign(target, { [key]: source[key] });
      }
    }
  }

  return deepMerge(target, ...sources);
}

function isObject(item: any): boolean {
  return item && typeof item === 'object' && !Array.isArray(item);
}

// Import browser language detection utility
import { getInitialLanguage } from '@/utils/browserLanguage';

// Get initial language with browser detection for first-time users
const initialLanguage = getInitialLanguage();

// Initialize i18n
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: deepMerge(
        {},
        enNavigation,
        enAuth,
        enForms,
        enFamilies,
        enDocumentation,
        enDocumentationPage,
        enProductDetailPage,
        enImports,
        enMarketing,
        enProductstable,
        enDashboard,
        enReportspage,
        enTeampage,
        enSettingspage,
        enAttributeGroupsPage,
        enAttributesPage,
        enFieldLabels,
        enSearch,
        enErrors,
        enPlanLimits,
        enLegal,
        enRequestOrganization,
        enCommon,
        enTours
      ),
      bigcommerce: enBigCommerce,
    },
    es: {
      translation: deepMerge(
        {},
        esNavigation,
        esAuth,
        esForms,
        esFamilies,
        esDocumentation,
        esDocumentationPage,
        esProductDetailPage,
        esImports,
        esMarketing,
        esProductstable,
        esDashboard,
        esReportspage,
        esTeampage,
        esSettingspage,
        esAttributeGroupsPage,
        esAttributesPage,
        esFieldLabels,
        esSearch,
        esErrors,
        esPlanLimits,
        esLegal,
        esRequestOrganization,
        esCommon,
        esTours
      ),
      bigcommerce: esBigCommerce,
    },
    de: {
      translation: deepMerge(
        {},
        deNavigation,
        deAuth,
        deForms,
        deFamilies,
        deDocumentation,
        deDocumentationPage,
        deProductDetailPage,
        deImports,
        deMarketing,
        deProductstable,
        deDashboard,
        deReportspage,
        deTeampage,
        deSettingspage,
        deAttributeGroupsPage,
        deAttributesPage,
        deFieldLabels,
        deSearch,
        deErrors,
        dePlanLimits,
        deLegal,
        deRequestOrganization,
        deCommon,
        deTours
      ),
      bigcommerce: deBigCommerce,
    },
    pt: {
      translation: deepMerge(
        {},
        ptNavigation,
        ptAuth,
        ptForms,
        ptFamilies,
        ptDocumentation,
        ptDocumentationPage,
        ptProductDetailPage,
        ptImports,
        ptMarketing,
        ptProductstable,
        ptDashboard,
        ptReportspage,
        ptTeampage,
        ptSettingspage,
        ptAttributeGroupsPage,
        ptAttributesPage,
        ptFieldLabels,
        ptSearch,
        ptErrors,
        ptPlanLimits,
        ptLegal,
        ptRequestOrganization,
        ptCommon,
        ptTours
      ),
      bigcommerce: ptBigCommerce,
    },
  },
  lng: initialLanguage,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;
